const catalogEn = {
  "products.title": "Products",
  "products.add": "Add product",
  "products.import": "Import",
  "products.export": "Export",
  "products.tab.all": "All",
  "products.tab.active": "Active",
  "products.tab.draft": "Draft",
  "products.tab.archived": "Archived",
  "products.search": "Search by title or SKU",
  "products.filter.vendor": "Vendor",
  "products.filter.type": "Type",
  "products.filter.tag": "Tag",
  "products.filter.clear": "Clear",
  "products.filter.clear_all": "Clear all",
  "products.filter.any": "Any",
  "products.sort": "Sort",
  "products.sort.-updated_at": "Updated (newest first)",
  "products.sort.-created_at": "Created (newest first)",
  "products.sort.created_at": "Created (oldest first)",
  "products.sort.title": "Product title A–Z",
  "products.sort.-title": "Product title Z–A",
  "products.col.product": "Product",
  "products.col.status": "Status",
  "products.col.variants": "Variants",
  "products.col.price": "Price",
  "products.col.vendor": "Vendor",
  "products.variants_count": "{n} variants",
  "products.empty_title": "Add your first product",
  "products.empty_body": "Products are what you sell. Add one, or import your catalogue from another platform or a spreadsheet.",
  "products.none_match": "No products match these filters.",
  "products.selected": "{n} selected",
  "products.select_all_matching": "Select all matching products",
  "products.all_matching_selected": "All matching products are selected.",
  "products.bulk.add_tags": "Add tags",
  "products.bulk.remove_tags": "Remove tags",
  "products.bulk.active": "Set as active",
  "products.bulk.draft": "Set as draft",
  "products.bulk.archived": "Archive",
  "products.bulk.publish": "Publish to storefront",
  "products.bulk.unpublish": "Hide from storefront",
  "products.bulk.delete": "Delete",
  "products.bulk.delete_confirm": "Delete {n} products? Orders keep their history.",
  "products.bulk.tags_prompt": "Tags (comma separated)",
  "products.bulk.done": "{n} products updated.",
  "products.bulk.started": "Working on it — this runs in the background.",
  "products.load_more": "Load more",
  "status.active": "Active",
  "status.draft": "Draft",
  "status.archived": "Archived",
  "status.unlisted": "Unlisted",
  "product.new": "Add product",
  "product.title": "Title",
  "product.title_placeholder": "Short sleeve t-shirt",
  "product.description": "Description",
  "product.media": "Media",
  "product.media_add": "Add images or videos",
  "product.media_drop": "Drop files here",
  "product.media_video": "Add video link",
  "product.media_video_prompt": "YouTube or Vimeo link",
  "product.media_alt": "Alt text",
  "product.media_save_first": "Save the product to add media.",
  "product.pricing": "Pricing",
  "product.price": "Price",
  "product.compare_at": "Compare-at price",
  "product.cost": "Cost per item",
  "product.cost_hint": "Customers won't see this.",
  "product.margin": "Margin",
  "product.profit": "Profit",
  "product.charge_tax": "Charge tax on this product",
  "product.inventory": "Inventory",
  "product.inventory_soon": "Stock per location arrives with inventory tracking.",
  "product.sku": "SKU",
  "product.barcode": "Barcode",
  "product.continue_selling": "Continue selling when out of stock",
  "product.shipping": "Shipping",
  "product.physical": "This is a physical product",
  "product.weight": "Weight",
  "product.hs_code": "HS code",
  "product.origin": "Country/Region of origin",
  "product.variants": "Variants",
  "product.add_options": "Add options like size or colour",
  "product.option_name": "Option name",
  "product.option_values": "Values",
  "product.option_value_placeholder": "Add another value",
  "product.add_option": "Add another option",
  "product.remove_option": "Remove option",
  "product.done": "Done",
  "product.variant": "Variant",
  "product.no_variants": "Add values to create variants.",
  "product.seo": "Search engine listing",
  "product.seo_title": "Page title",
  "product.seo_description": "Meta description",
  "product.seo_handle": "URL handle",
  "product.status": "Status",
  "product.online_store": "Storefront",
  "product.published": "Visible on the storefront",
  "product.schedule": "Schedule publishing",
  "product.organization": "Product organization",
  "product.category": "Category",
  "product.category_search": "Search categories",
  "product.type": "Type",
  "product.vendor": "Vendor",
  "product.collections": "Collections",
  "product.tags": "Tags",
  "product.tags_hint": "Press Enter to add a tag",
  "product.template": "Theme template",
  "product.gift_card": "This is a gift card",
  "product.metafields": "Custom fields",
  "product.metafields_none": "No custom field definitions yet. Add them in Settings → Custom fields.",
  "product.duplicate": "Duplicate",
  "product.view": "View on store",
  "product.delete": "Delete product",
  "product.delete_confirm": "Delete {title}? This can't be undone, but orders keep their history.",
  "product.saved": "Product saved",
  "product.created": "Product created",
  "product.conflict": "Someone else changed this product. Reload to see their changes.",
  "product.unsaved_new": "Unsaved product",
  "collections.title": "Collections",
  "collections.add": "Create collection",
  "collections.empty_title": "Group your products into collections",
  "collections.empty_body": "Collections help customers find products by category, season or sale.",
  "collections.col.products": "Products",
  "collections.col.conditions": "Conditions",
  "collections.type": "Collection type",
  "collections.manual": "Manual",
  "collections.manual_hint": "Add products one by one.",
  "collections.smart": "Automated",
  "collections.smart_hint": "Products that match conditions are added automatically.",
  "collections.conditions": "Conditions",
  "collections.match_all": "all conditions",
  "collections.match_any": "any condition",
  "collections.match": "Products must match:",
  "collections.add_condition": "Add another condition",
  "collections.products": "Products",
  "collections.browse": "Browse products",
  "collections.sort": "Sort",
  "collections.sort.manual": "Manually",
  "collections.sort.best_selling": "Best selling",
  "collections.sort.title_asc": "Title A–Z",
  "collections.sort.title_desc": "Title Z–A",
  "collections.sort.price_asc": "Lowest price",
  "collections.sort.price_desc": "Highest price",
  "collections.sort.created_desc": "Newest",
  "collections.sort.created_asc": "Oldest",
  "collections.no_products": "No products in this collection yet.",
  "collections.delete_confirm": "Delete {title}? Products stay in your store.",
  "collections.pick": "Add products",
  "rule.title": "Product title",
  "rule.type": "Product type",
  "rule.vendor": "Product vendor",
  "rule.tag": "Product tag",
  "rule.price": "Price",
  "rule.compare_at_price": "Compare-at price",
  "rule.weight": "Weight (kg)",
  "rule.variant_title": "Variant title",
  "rule.metafield": "Custom field",
  "rel.equals": "is equal to",
  "rel.not_equals": "is not equal to",
  "rel.contains": "contains",
  "rel.not_contains": "does not contain",
  "rel.starts_with": "starts with",
  "rel.ends_with": "ends with",
  "rel.greater_than": "is greater than",
  "rel.less_than": "is less than",
  "rel.is_empty": "is empty",
  "rel.is_not_empty": "is not empty",
  "import.title": "Import products by CSV",
  "import.hint": "Upload a product CSV in the standard export format used by most e-commerce platforms. Images are fetched from their URLs.",
  "import.choose": "Choose CSV file",
  "import.preview": "Preview",
  "import.rows": "{rows} rows, {products} products",
  "import.unmapped": "Ignored columns",
  "import.update_existing": "Overwrite products with the same handle",
  "import.start": "Import products",
  "import.running": "Importing… {done} of {total}",
  "import.done": "Import finished",
  "import.summary": "{created} created, {updated} updated, {skipped} skipped, {failed} failed",
  "import.errors": "Problems",
  "import.download_errors": "Download error report",
  "import.sample": "Download a sample CSV",
  "export.title": "Export products",
  "export.scope": "Export",
  "export.all": "All products",
  "export.filtered": "Products matching your search and filters",
  "export.selected": "{n} selected products",
  "export.excel": "CSV for Excel (keeps Arabic text readable)",
  "export.plain": "Plain CSV",
  "export.start": "Export products",
  "export.running": "Exporting… {done} of {total}",
  "export.ready": "Your export is ready.",
  "export.download": "Download",
  "job.failed": "Something went wrong: {error}",
  "custom.title": "Custom fields",
  "custom.hint": "Add fields to products, variants and collections, and create content types for things like designers or size charts.",
  "custom.definitions_for": "Custom fields for {owner}",
  "custom.owner.product": "Products",
  "custom.owner.variant": "Variants",
  "custom.owner.collection": "Collections",
  "custom.add_definition": "Add definition",
  "custom.name": "Name",
  "custom.namespace_key": "Namespace and key",
  "custom.type": "Type",
  "custom.description": "Description",
  "custom.choices": "Allowed values (one per line)",
  "custom.storefront": "Expose to themes on the storefront",
  "custom.delete_definition": "Delete definition",
  "custom.delete_definition_confirm": "Delete {name}? Values already saved stay as unstructured custom fields.",
  "custom.metaobjects": "Content types",
  "custom.add_metaobject_type": "Add definition",
  "custom.entries": "{n} entries",
  "custom.fields": "Fields",
  "custom.add_field": "Add field",
  "custom.field_key": "Key",
  "custom.required": "Required",
  "custom.display_name": "Display name field",
  "custom.open_entries": "Manage entries",
  "custom.add_entry": "Add entry",
  "custom.handle": "Handle",
  "custom.no_entries": "No entries yet.",
  "type.single_line_text": "Single line text",
  "type.multi_line_text": "Multi-line text",
  "type.number_integer": "Integer",
  "type.number_decimal": "Decimal",
  "type.boolean": "True or false",
  "type.date": "Date",
  "type.date_time": "Date and time",
  "type.url": "URL",
  "type.color": "Colour",
  "type.money": "Money",
  "type.weight": "Weight",
  "type.dimension": "Dimension",
  "type.volume": "Volume",
  "type.rating": "Rating",
  "type.json": "JSON",
  "type.file_reference": "File",
  "type.product_reference": "Product",
  "type.variant_reference": "Variant",
  "type.collection_reference": "Collection",
  "type.metaobject_reference": "Content entry",
  "type.list": "List of {type}",
  "products.sort.updated_at": "Updated (oldest first)",
  "products.sort.inventory": "Inventory (low to high)",
  "products.sort.-inventory": "Inventory (high to low)",
  "products.sort.product_type": "Product type A–Z",
  "products.sort.-product_type": "Product type Z–A",
  "products.sort.vendor": "Vendor A–Z",
  "products.sort.-vendor": "Vendor Z–A",
  "products.col.inventory": "Inventory",
  "products.col.category": "Category",
  "products.inv.untracked": "Inventory not tracked",
  "products.inv.in_stock": "{n} in stock",
  "products.inv.for_variants": "{n} in stock for {v} variants",
  "products.filter.collection": "Collection",
  "products.bulk.more": "More actions",
  "products.bulk.add_collections": "Add to collection(s)",
  "products.bulk.remove_collections": "Remove from collection(s)",
  "products.bulk.add_tags_title": "Add tags to {n} products",
  "products.bulk.remove_tags_title": "Remove tags from {n} products",
  "products.bulk.add_tags_hint": "Type a tag and press Enter. Existing tags are suggested.",
  "products.bulk.remove_tags_hint": "Products that don't have these tags are left as they are.",
  "products.bulk.add_collections_title": "Add {n} products to collections",
  "products.bulk.remove_collections_title": "Remove {n} products from collections",
  "products.bulk.no_manual_collections": "No manual collections yet. Smart collections pick products by their conditions.",
  "product.quantity": "Quantity",
  "product.has_sku": "This product has a SKU or barcode",
  "product.barcode_hint": "ISBN, UPC, GTIN, etc.",
  "product.hs_code_hint": "Harmonized System code, used by customs",
  "product.media_alt_hint": "Describe the image for customers who use screen readers.",
  "product.variants_total": "{n} variants · Total inventory: {total} available",
  "product.options": "Options",
  "product.variant_saved": "Variant saved",
  "product.variant_missing": "This variant doesn't exist any more.",
  "product.variant_image": "Variant image",
  "product.variant_delete": "Delete variant",
  "product.variant_delete_confirm": "Delete {title}? Its stock is written off.",
  "rule.category": "Product category",
  "rule.inventory_stock": "Inventory stock",
} as const;

export default catalogEn;
